<template>
  <SAIBtn
    class="sai-btn-alert"
    v-on="$listeners"
    v-bind="$attrs"
    :size="size"
    :padding="padding"
    :rounded="false"
    :label="undefined"
    unelevated
    outline
    no-caps
    :border-width="borderWidth"
  >
    <span
      v-if="alerts"
      class="bg-negative q-mr-sm text-white alert text-weight-bold"
    >
      {{ alerts }}
    </span>
    <span class="inner-label text-weight-bold">
      {{ label }}
    </span>
  </SAIBtn>
</template>

<script>
export default {
  name: 'SAIBtnAlert',
  props: {
    label: String,
    alerts: Number,
    size: {
      type: String,
      default: '12px'
    },
    padding: {
      type: String,
      default: 'sm 12px'
    },
    borderWidth: {
      type: String,
      default: '1px'
    }
  },
  components: {
    SAIBtn: () => import('../../atom/sai-btn')
  }
};
</script>

<style lang="sass" scoped>
.sai-btn-alert::v-deep
  .q-btn__wrapper
     background: $primary-pale

  .inner-label
    color: $grey-8
    font-size: 12px

  .alert
    border-radius: 50%
    font-size: 10px
    height: 17px
    min-width: 17px
    line-height: 17px

  &.disabled
    .q-btn__wrapper
      background: $grey-1
</style>
